import { MarketPeriods } from "app/utils/const";
import uniqBy from "lodash/uniqBy";
import * as api from "../../api/positionMatrixApi";
const PositionMatrixListModel = {
  state: {
    isPositionMatrixListLoading: false,
    total: 0,
    positionMatrixList: [] as Array<any>,
    positionMatrixModalItem: null,
    isPositionMatrixModalItemLoading: false,
    isPositionMatrixModalOpen: false,
    positionMatrixModalEvent: null,
  },
  reducers: {
    setPositionMatrixListTotal: (
      state: Record<string, any>,
      payload: number
    ): any => {
      return { ...state, total: payload };
    },

    setPositionMatrixModalItemRequest(state: Record<string, any>): any {
      return {
        ...state,
        positionMatrixModalItem: null,
        isPositionMatrixModalItemLoading: true,
      };
    },

    setPositionMatrixListRequest(state: Record<string, any>): any {
      return { ...state, isPositionMatrixListLoading: true };
    },

    setPositionMatrixListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        positionMatrixList: payload.positionMatrixList,
        isPositionMatrixListLoading: false,
      };
    },

    setPositionMatrixModalItemSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        positionMatrixModalItem: payload.positionMatrixModalItem,
        isPositionMatrixModalItemLoading: false,
      };
    },

    purgePositionMatrixList: (state: Record<string, any>): any => {
      return { ...state, positionMatrixList: [] };
    },
    purgePositionMatrixModalItem: (state: Record<string, any>): any => {
      return { ...state, positionMatrixModalItem: null };
    },
    purgePositionMatrixModalEvent: (state: Record<string, any>): any => {
      return { ...state, positionMatrixModalEvent: null };
    },
    setPositionMatrixModalEvent: (
      state: Record<string, any>,
      payload: any
    ): any => {
      return { ...state, positionMatrixModalEvent: payload };
    },
    openPositionMatrixModal: (state: Record<string, any>): any => {
      return { ...state, isPositionMatrixModalOpen: true };
    },
    closePositionMatrixModal: (state: Record<string, any>): any => {
      return {
        ...state,
        isPositionMatrixModalOpen: false,
        positionMatrixModalEvent: null,
        positionMatrixModalItem: null,
      };
    },
  },
  effects: {
    async setPositionMatrixList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setPositionMatrixListRequest();
      return api
        .fetchPositionMatrices(MarketPeriods.FULL_EVENT)
        .then((positionMatrixData: any) => {
          if (
            positionMatrixData.data !== undefined &&
            positionMatrixData.data.positionMatrices !== undefined
          ) {
            return {
              total: positionMatrixData.data.total,
              fullEventList: positionMatrixData.data.positionMatrices,
              firstHalfListPromise: api.fetchPositionMatrices(
                MarketPeriods.FIRST_HALF
              ),
            };
          }
        })
        .then(resp => {
          resp.firstHalfListPromise.then(firstHalfListResult => {
            // Combine FIRST_HALF and FULL_EVENT arrays
            const fullList = resp.fullEventList.concat(
              firstHalfListResult.data.positionMatrices
            );
            // Filter out duplicate position matrices
            const uniqueList = uniqBy(fullList, "eventId");
            this.setPositionMatrixListSuccess({
              positionMatrixList: uniqueList,
              total: resp.total,
            });
          });
        })
        .catch(error => {
          throw error;
        });
    },

    async setPositionMatrixModalItem(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setPositionMatrixModalItemRequest();
      // API only returns HALF_TIME or FULL_EVENT, not both, so we have to call both and combine
      // them into one object.
      return api
        .fetchPositionMatrix(payload.eventId, MarketPeriods.FULL_EVENT)
        .then((positionMatrixData: any) => {
          if (
            positionMatrixData !== undefined &&
            positionMatrixData.data.positionMatrices
          ) {
            this.setPositionMatrixModalItemSuccess({
              positionMatrixModalItem:
                positionMatrixData.data.positionMatrices[0],
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default PositionMatrixListModel;
